<template>
  <div class="basecard">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  .basecard {
    @apply flex flex-col gap-4 rounded-lg p-5 overflow-hidden bg-pure-white border border-slate-300;
  }

  .basecard :deep(.basecard) {
    @apply rounded-md p-4;
  }

  .dark-section .basecard {
    @apply border-slate-600;
  }
}
</style>
